import React, { Component } from 'react';
import {

  Col,
  Row,
  Container,
  Card, CardImg, CardImgOverlay,
  Button
} from 'reactstrap';

import LandingItem from '../../../components/LandingPage/LandingItem';
import '../../../css/components/LandingPage/landingPage.css';
import Logout from '../../../components/Logout/Logout';

const CardLanding = process.env.PUBLIC_URL + '/assets/img/landingPage/landingPage.png';

let isIE = /*@cc_on!@*/false || !!document.documentMode;

const styles = {
  header: {
    height: '100vh',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundColor: '#2b2059'
  },

  content: {
    height: '100%',
    width: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    color: 'black'
  },
  card: {
    display: isIE == true ? 'block' : 'flex',//handle IE browswer
    backgroundColor: 'transparent',
    border: 'none'
  }
}

class LandingPage extends Component {
  constructor(props) {
    super(props)
    this.state = {

    };
    this.logout = this.logout.bind(this);
  }

  logout() {
    Logout.helper();
  }
  render() {
    return (
      <div style={styles.header}>
        <div style={styles.content} className="app flex-row align-items-center">
          <Container>
            <Row className="justify-content-center">
              <Col md="8">
                <Card inverse style={styles.card} >
                  <CardImg width="100%" src={CardLanding} alt="backgroud" />
                  <CardImgOverlay>
                    <Row style={{ paddingBottom: '2%' }}>
                      <Col md="10" style={{ paddingLeft: '4%' }}>
                        <h2 style={{ color: "black" }}> <strong>Welcome to RedRadar !</strong> </h2>
                      </Col>
                      <Col md="2">
                        <Button outline color="dark" onClick={this.logout}>Logout</Button>
                      </Col>
                    </Row>
                    {/*Item for the submenu description*/}
                    <LandingItem />
                  </CardImgOverlay>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>

    );
  }
}
export default LandingPage;
